import script from "./NotificationDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=79e0a6f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e0a6f7"]])

export default __exports__